import encryptData from "../../views/middleware";
import axios from "./axios";
import { getEncryptionPayload } from "../../utils/encryptionFlag";

async function axiosRequestPostNodeJS(
  service,
  body = {},
  params = {},
  contentType = "application/json"
) {
  try {
    const baseURL = `/${service}`;

    const targetURL = baseURL;

    let headerConfig = {
      headers: {
        URL: baseURL,
        "Content-Type": contentType,
      },
      params,
      cancelToken: axios.axiosCancel().getCancelToken(),
    };
    let postData;

    const isEncryptionPayload = getEncryptionPayload();

    if (isEncryptionPayload && !(body instanceof FormData)) {
      const { data, iv, AESKey } = await encryptData(body);

      postData = { data: data, iv: iv };

      headerConfig.headers["x-session-info"] = AESKey;
    } else {
      postData = body;
    }
    const response = await axios.post(targetURL, postData, headerConfig);

    return response;
  } catch (e) {
    console.error("errror ----- httpsevice file--", e);
    throw e;
  }
}
async function axiosRequestDeleteNodeJS(service, params = {}) {
  try {
    const baseURL = `/${service}`;

    const targetURL = baseURL;

    const response = await axios.delete(targetURL, {
      headers: { URL: baseURL },
      // timeout: 3000,
      data: { ...params },
      cancelToken: axios.axiosCancel().getCancelToken(),
    });

    return response;
  } catch (e) {
    console.error("errror ----- httpsevice file--", e);
    throw e;
  }
}
async function axiosRequestGetNodeJS(service, params = {}) {
  try {
    const baseURL = `/${service}`;

    const targetURL = baseURL;

    const response = await axios.get(targetURL, {
      headers: { URL: baseURL },
      // timeout: 3000,
      params,
      cancelToken: axios.axiosCancel().getCancelToken(),
    });

    return response;
  } catch (error) {
    console.error("errror ----- httpsevice file--", error);
    throw error;
  }
}

export const axiosProviderNode = {
  get: axiosRequestGetNodeJS,
  post: axiosRequestPostNodeJS,
  delete: axiosRequestDeleteNodeJS,
};
